const Signup = () => {
    return (
        <li>
            <a href="/signup">Sign up</a>
        </li>
    );
};

export default Signup;
